import { Menu, Tooltip, UnstyledButton } from '@mantine/core';

import { TSDListItem } from '@e-origin/contracts';
import { getTsdSimulatorAvailability, TSDStatus, TSDTestResponseType, TSDType } from '@e-origin/shared';

import { actionsIcon, downloadIcon } from '@assets';
import { getTsdCombinedOptions, getTsdPrelodgedOptions, getTsdTransferredOptions, SIMULATE_RESPONSE } from '@components';
import classes from '@components/TableActions/TableActions.module.css';

interface TsdSimulatorActionsMenuProps {
  tsd: TSDListItem;
  tsdView: TSDType;
  onSelect(messageType: TSDTestResponseType): void;
}

const getTsdSimulatorOptions = (tsdView: TSDType) => {
  switch (tsdView) {
    case TSDType.COMBINED:
      return getTsdCombinedOptions();

    case TSDType.PRELODGED:
      return getTsdPrelodgedOptions();

    case TSDType.TRANSFERRED:
      return getTsdTransferredOptions();

    default:
      return [];
  }
};

const getDisabledReason = (tsd: TSDListItem, messageType: TSDTestResponseType): string | undefined => {
  const availability = getTsdSimulatorAvailability(messageType, {
    status: tsd?.generalInfo?.status as TSDStatus,
    frn: tsd?.messageInfo?.FRN,
    hasInvalidation: !!tsd.customsState?.invalidationDecision?.invalidationInitiatedByCustoms,
  });

  return availability.reason;
};

export const TsdSimulatorActionsMenu: React.FC<TsdSimulatorActionsMenuProps> = ({ tsd, tsdView, onSelect }) => {
  const responseOptions = getTsdSimulatorOptions(tsdView);

  if (!responseOptions.length) {
    return null;
  }

  return (
    <Menu position="left-start">
      <Menu.Target>
        <UnstyledButton className={`${classes.svgIcon} ${classes.svgLightColor}`}>
          <img src={actionsIcon} alt="contextual" />
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        {responseOptions.map(({ type, label }) => {
          const disabledReason = getDisabledReason(tsd, type);

          const menuItem = (
            <Menu.Item
              key={type}
              leftSection={<img src={downloadIcon} alt={SIMULATE_RESPONSE} />}
              disabled={Boolean(disabledReason)}
              onClick={() => onSelect(type)}
            >
              {label}
            </Menu.Item>
          );

          if (!disabledReason) {
            return menuItem;
          }

          return (
            <Tooltip key={type} label={disabledReason} withinPortal withArrow position="top">
              {menuItem}
            </Tooltip>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};
